import {FornecedoresPage} from '@components/fornecedores/pages/FornecedoresPage.tsx';
import {DefaultPageProps} from "@models/DefaultProps.ts";
import React, {useEffect, useState} from "react";
import {IProduto} from "@models/produtos/produto.ts";
import {useLocation, useNavigate, useSearchParams} from "react-router";
import {Grid, Paper, Tab, Tabs} from "@mui/material";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {GetProdutos} from "@components/produtos/endpoints/__produto_endpoints.ts";
import {ProdutoInformacao} from "@components/produtos/ProdutoInformacao.tsx";
import {SolicitacoesPage} from "@components/solicitacoes/pages/solicitacoes/SolicitacoesPage.tsx";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export interface ProdutoPageProps extends DefaultPageProps {
	EndComponent?: (p: IProduto) => React.ReactNode;
}

type tabs = 'Informacoes' | 'Solicitacoes' | 'Fornecedores'

export const ProdutoPage: React.FC<ProdutoPageProps> = (props) => {
	const location = useLocation();
	const navigate = useNavigate();

	const {Get} = useApi();
	const {EndComponent} = props;

	const [searchParams] = useSearchParams();
	const [tab, setTab] = useState<tabs>('Informacoes');
	const [produto, setProduto] = useState<IProduto | undefined>(undefined);
	const [produtoId] = useState(searchParams.get('produtoId') ?? undefined);
	
	useEffect(() => {
		setTab(location.hash.slice(1) as tabs || 'Informacoes');
	}, [location.hash]);
	
	useEffect(() => {
		if (produtoId) {
			Get(GetProdutos({id: [Number(produtoId)], deveIncluir: ['Fornecedores']}, {
				page: 1,
				pageSize: 1,
			})).then(x => {
				if (x.hasData) {
					setProduto(x.items[0]);
				}
			});
		}
	}, [produtoId]);
	
	return (
		<DefaultContainer titulo={props.hideHeader ? '' : 'ProdutoPage'} component={Paper} size={'large'}>{
			produto && <Grid size={12}>
                <Grid container>
                    <Grid size={12}>
                        <ProdutoInformacao variant={'list'}
                                           value={produto}
						                   {...EndComponent}/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid size={12}>
                        <Tabs value={tab} onChange={(_e, v) => {
							navigate({
								pathname: location.pathname,
								search: location.search,
								hash: v,
							});
						}}>
                            <Tab value={'Informacoes'} label={'Informações'}/>
                            <Tab value={'Solicitacoes'} label={'Solicitações'}/>
                            <Tab value={'Fornecedores'} label={'Fornecedores'}/>
                        </Tabs>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid size={12}>
						{tab == 'Informacoes' && <Grid>Informações</Grid>}
                        {tab == 'Solicitacoes' && <SolicitacoesPage hideHeader filtros={{produtosId: [produto.id]}}/>}
						{tab == 'Fornecedores' && <FornecedoresPage hideHeader filtros={{produtoIds: [produto.id]}}/>}
                    </Grid>
                </Grid>
            </Grid>
		}
		</DefaultContainer>
	);
};